<template>
  <div class="sign-in">
    <div class="box">
      <form @submit.prevent="signIn">
        <b-field label="Username">
          <b-input v-model="username" />
        </b-field>
        <b-field label="Password">
          <b-input type="password" v-model="password" />
        </b-field>
        <b-message type="is-warning" v-if="errMsg">{{ errMsg }}</b-message>
        <div class="buttons">
          <button type="submit" class="button">Sign In</button>
        </div>
      </form>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SignIn',
  data () {
    return {
      username: '',
      password: '',
      errMsg: null
    }
  },
  methods: {
    signIn () {
      this.errMsg = null
      this.$api('signIn', { username: this.username, password: this.password })
        .then(resp => {
          this.$store.dispatch('setUser', resp.name)
          this.$router.replace('/')
        })
        .catch(err => {
          this.errMsg = err
        })
    }
  }
}
</script>

<style>
  .sign-in .box {
    width: 300px;
    margin: 5% auto 0 auto;
  }
</style>
